import { Popover, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Interior from "../../../arrangement/Interior";
import ChangeSizeDialog from "../popovers/ChangeSizeDialog";
import { useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Grid from "@material-ui/core/Grid";
import { InputBase } from "@material-ui/core";
import { TabsListUnstyled, TabsUnstyled, TabUnstyled, tabUnstyledClasses } from "@mui/base";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import styled from "@emotion/styled";
import Graphics from "./Graphics";
import Booth from "./Booth";

const TabsList = styled(TabsListUnstyled)`
  white-space: nowrap;
  overflow-x: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  padding-top: 12px;
  padding-bottom: 4px;
  margin-bottom: -8px;
  box-sizing: content-box;
`;

const Tab = styled(TabUnstyled)`
  background-color: #fff;
  color: #939599;
  padding: 6px 12px;
  outline: none;
  border-width: 0 0 2px 0;
  border-bottom-color: transparent;
  border-style: solid;
  box-shadow: none;
  font-size: 18px;

  &:first-of-type {
    margin-left: 50px;
  }

  &:last-of-type {
    margin-right: 50px;
  }

  &:hover {
    border-bottom-color: #c91113;
    color: #3a415a;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: #fff;
    color: #3a415a;
    border-bottom-color: #c91113;
  }

  &:not(:last-of-type)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 2px;
    bottom: 2px;
    width: 1px;
    height: 100%;
    background-color: #e5e5e5;
  }
`;

const GridStyled = styled(Grid)(({ theme }) => ({
  display: "flex",
  backgroundColor: "#fff",
  border: "1px solid #E2E2E2",
  borderRadius: "4px",
  padding: "10px",
  minWidth: "240px",
  width: "100%",
  maxWidth: "80%",
  marginRight: "8px",
  [theme.breakpoints.up("lg")]: {
    minWidth: "auto",
    maxWidth: "100%",
    marginRight: 0,
    marginBottom: "8px",
    padding: "12px",
  },
  "&:hover": {
    border: "1px solid #939599",
  },
}));

export default function Interiors({ propBooth, exhibition, type, headerLabel }) {
  const theme = useTheme();
  const params = useParams();
  const currentExhibition = exhibition || APP.richMetadata.metadata.Exhibitions.find(
    (exhi) => exhi.id == params.exhibitionId
  );
  const interiors = currentExhibition?.InteriorSet.InteriorsForInteriorSets.map((ifis) => ifis.Interior);
  const furniture = interiors?.filter((inter) => inter.Type.Name == type);
  const booth = currentExhibition?.BoothSet.BoothsForBoothSets.find(
    (bth) => bth.id == APP.arrangement?.state.booth?.id || params.boothId
  );
  const smallestSize = propBooth?.FormsForBooths?.map((ffb) => ffb.Size)?.sort((a, b) =>
    a.Name.localeCompare(b.Name)
  )[0].Name;
  const sizes = _.uniq(propBooth?.FormsForBooths?.map((ffb) => ffb.Size));
  const [size, setSize] = useState(propBooth?.selectedSize || smallestSize);
  const [tab, setTab] = useState(window.innerWidth > 1200 ? false : 1);
  let oldSize = "";
  const [possibleUploads, setPossibleUploads] = useState([]);
  const letterArticle = APP.metadata.Artikel.find((a) => a.Artikelnummer == "Letter");
  const state = APP.arrangement?.state || false;
  const fontColors =
    propBooth?.ColorSetsForCompanyName?.length > 0
      ? propBooth?.ColorSetsForCompanyName[0].ColorSet.ColorForColorSet.map(
          (c) => "#" + c.Color.getHexString()
        )
      : [];
  let defaultColor =
    state?.companyColor === ""
      ? propBooth?.ColorSetsForCompanyName?.length > 0
        ? "#" +
          propBooth?.ColorSetsForCompanyName[0].ColorSet?.ColorForColorSet.find(
            (col) => col.Default
          ).Color.getHexString()
        : ""
      : state.companyColor;
  const [currentColor, setCurrentColor] = useState(defaultColor);

  useEffect(() => {
    if (!size) {
      setSize(propBooth?.selectedSize || smallestSize);
    }
  }, [propBooth?.selectedSize, smallestSize]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    // const defaultCompanyColor = booth?.ColorSetsForCompanyName?.length>0 ? '#'+booth?.ColorSetsForCompanyName[0].ColorSet?.ColorForColorSet.find(col => col.Default).Color.getHexString() : '';
    // APP.arrangement.state.companyColor = defaultCompanyColor;
    if ((!currentColor || currentColor == "") && propBooth) {
      defaultColor =
        "#" +
        propBooth?.ColorSetsForCompanyName?.[0].ColorSet?.ColorForColorSet.find(
          (col) => col.Default
        ).Color.getHexString();
      setCurrentColor(defaultColor);
      state.companyColor = defaultColor;
    }
    console.log("currentColor", currentColor, defaultColor);
  }, [propBooth]);

  const handleWindowSizeChange = () => {
    setTab(window.innerWidth > 1200 ? false : 1);
  };

  const setBoothSize = (size) => {
    const changeSize = () => {
      const comb = propBooth.FormsForBooths.find((ffb) => ffb.Size.Name === size);
      if (comb) {
        APP.arrangement.setSelectedComb(comb);
        APP.arrangement.clearBooth();
        APP.arrangement.popover = undefined;
        APP.dirty();
      } else {
        console.error("Form/Size combination not found! Check DB");
      }
    };
    const revertChange = () => {
      APP.arrangement.popover = undefined;
      setSize(oldSize);
      APP.dirty();
    };
    if (APP.arrangement.booth.interiors.length > 0) {
      APP.arrangement.setPopover({
        positionX: window.innerWidth / 2,
        positionY: window.innerHeight / 2,
        content: ChangeSizeDialog({
          onSuccess: changeSize,
          onDecline: revertChange,
        }),
      });
    } else {
      changeSize();
    }
  };
  const formsForBooths = propBooth
    ? propBooth.FormsForBooths?.filter((ffb) => ffb.Size.Name == size)
    : [];
  const { selectedComb, selectedColors } = APP.arrangement ? APP.arrangement?.state : {};
  const colorSetsForForm = selectedComb?.Form?.ColorSetsForForms;

  const changeComb = (comb) => {
    APP.arrangement.setSelectedComb(comb);
  };

  const sortColorSetsForForm = (a, b) => {
    return a.ColoringText.localeCompare(b.ColoringText);
  };
  // TODO: Later: Drag and Drop isnt the best anymore (mobile use....)
  const draggable = (element, interior) => {
    APP.interactionHandler
      .draggable(element)
      .setDragObject3D((handle) => APP.interactionHandler.createDragInterior(interior));
  };

  const handleInterorClick = (event, interior) => {
    const interiorArrangement = new Interior(APP.arrangement, interior, booth);
    booth.addInterior(interiorArrangement);
    APP.update3d();
    APP.dirty();
  };

  const changeAmount = (item, amount) => {
    APP.arrangement.booth.updateExtras(item, amount);
  };

  // Über Mesh/Material schauen welche verfügbar sind
  useEffect(() => {
    const possibilities = [];
    if (APP.arrangement?.booth.jaco3d.poster1?.exists) possibilities.push("poster1");
    if (APP.arrangement?.booth.jaco3d.poster2?.exists) possibilities.push("poster2");
    if (APP.arrangement?.booth.jaco3d.logo1?.exists) possibilities.push("logo1");
    if (APP.arrangement?.booth.jaco3d.logo2?.exists) possibilities.push("logo2");
    setPossibleUploads(possibilities);
    if (state.companyColor === "") state.companyColor = currentColor;
  }, [
    APP.arrangement?.booth?.jaco3d.poster1,
    APP.arrangement?.booth?.jaco3d.poster2,
    APP.arrangement?.booth?.jaco3d.logo1,
    APP.arrangement?.booth?.jaco3d.logo2,
    APP.arrangement?.booth?.jaco3d.companyName,
  ]);

  const handleUpload = (file, poster) => {
    let code = APP.configuration.Code;
    const uploadFile = () => {
      APP.wkfgBackendApi.uploadContent(`Konfiguration/${code}`, [file]).then(([path]) => {
        handleFileChange(path, poster);
      });
    };
    if (code == null) {
      APP.save({
        quiet: true,
        noFotoSnapshots: true,
        skipURLUpdate: true,
        callback: (configuration) => {
          code = configuration.Code;
          uploadFile();
        },
      });
    } else {
      uploadFile();
    }
  };

  const handleFileChange = (path, poster) => {
    state[poster].url = path;
    APP.arrangement.booth?.jaco3d?.prepareCanvas(poster);
    APP.ui.dirty();
  };

  const handleSettingsChange = (poster, setting, value) => {
    state[poster][setting] = value;
    APP.arrangement.booth?.jaco3d?.updateCanvasTexture(poster);
    APP.ui.dirty();
  };

  const resetSize = (poster) => {
    state[poster].x = 50;
    state[poster].y = 50;
    state[poster].zoom = 50;
    APP.arrangement.booth?.jaco3d?.updateCanvasTexture(poster);
    APP.ui.dirty();
  };

  const changeText = (txt) => {
    APP.arrangement.changeCompName(txt);
    APP.arrangement.booth.jaco3d.updateTextCanvas();
  };

  const changeFontColor = (color) => {
    setCurrentColor(color);
    state.companyColor = color;
    APP.arrangement.booth?.jaco3d?.updateTextCanvas();
    APP.ui.dirty();
  };

  // START TYPE BOOTH
  if (type === "Booth") {
    return (
      <>
        <Booth booth={propBooth} />
      </>
    );
  }
  // START TYPE GRAPHICS
  else if (type === "Graphics") {
    return (
      <>
        <Graphics booth={propBooth} />
      </>
    );
  }
  // START OTHER TYPES
  else {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          whiteSpace: "nowrap",
          overflowY: "auto",
          padding: "8px 0 18px 18px",
          [theme.breakpoints.up("lg")]: {
            flexDirection: "column",
            whiteSpace: "unset",
            overflowY: "auto",
            padding: "18px 18px 0 18px",
          },
        }}
        onMouseDown={() => {}}
        onTouchStart={() => {}}
      >
        <Typography
          variant="h6"
          sx={{
            color: "#3A415A",
            fontWeight: "700",
            paddingBottom: "8px",
            borderBottom: "1px solid #E2E2E2",
            marginBottom: '10px',
            display: "none",
            [theme.breakpoints.up("lg")]: {
              display: "block",
            },
          }}
        >
          {headerLabel}
        </Typography>
        {furniture?.map((item) => (
          <GridStyled
            container
            spacing={0}
            key={item.id}
            className="interiorDragListItem"
            onDragStart={() => {
              console.log("dragging", item);
            }}
          >
            <Box component={Grid} item xs={12} lg={8}>
              <Typography
                sx={{
                  userSelect: "none",
                  textAlign: "left",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  marginBottom: "4px",
                  color: "#3A415A",
                  fontWeight: 700,
                  fontSize: "16px",
                }}
              >
                {item.Displayed_Name}
              </Typography>

              {item.Dimensions && (
                <Box
                  sx={{
                    display: "none",
                    [theme.breakpoints.up("lg")]: {
                      display: "block",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      userSelect: "none",
                      marginBottom: "7px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      color: "#3A415A",
                    }}
                  >
                    {item.Dimensions}
                  </Typography>
                </Box>
              )}

              {item.NumberInput && (
                // Start for when Item is Number Input (GLB also doesnt appear as an object on screen)
                <Box
                  sx={{
                    display: "none",
                    [theme.breakpoints.up("lg")]: {
                      display: "block",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "8px",
                      marginBottom: "8px",
                      backgroundColor: "#E2E2E2",
                      borderRadius: "4px",
                      width: "100%",
                      maxWidth: "84px",
                      marginLeft: "auto",
                      marginRight: "10px",
                      [theme.breakpoints.up("lg")]: {
                        marginLeft: 0,
                        marginRight: 0,
                        marginTop: 0,
                      },
                    }}
                  >
                    <IconButton
                      onClick={(e) =>
                        changeAmount(
                          item,
                          isNaN(
                            parseInt(
                              APP.arrangement.booth.extras.find(
                                (extra) => extra.id === item.DefaultArticle?.id
                              )?.amount
                            )
                          )
                            ? 0
                            : parseInt(
                                APP.arrangement.booth.extras.find(
                                  (extra) => extra.id === item.DefaultArticle?.id
                                )?.amount
                              ) - 1
                        )
                      }
                      sx={{
                        p: "6px",
                        borderRadius: "4px 0 0 4px",
                        color:
                          APP.arrangement.booth.extras.find(
                            (extra) => extra.id === item.DefaultArticle?.id
                          )?.amount ?? 0 >= 1
                            ? "#3A415A"
                            : "#939599",
                        backgroundColor: "#E2E2E2",
                        height: "22px",
                        "&:hover": {
                          backgroundColor: "#E2E2E2 !important",
                        },
                      }}
                    >
                      <RemoveIcon sx={{ fontSize: "12px" }} />
                    </IconButton>
                    <InputBase
                      inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                      value={
                        APP.arrangement.booth.extras.find(
                          (extra) => extra.id === item.DefaultArticle?.id
                        )?.amount ?? 0
                      }
                      size="small"
                      onChange={(e) => changeAmount(item, e.target.value)}
                      style={{
                        width: "100%",
                        minWidth: "34px",
                        borderRadius: "4px",
                        padding: "7px",
                        backgroundColor: "#fff",
                        height: "18px",
                        fontSize: "12px",
                      }}
                    />
                    <IconButton
                      onClick={(e) =>
                        changeAmount(
                          item,
                          isNaN(
                            parseInt(
                              APP.arrangement.booth.extras.find(
                                (extra) => extra.id === item.DefaultArticle?.id
                              )?.amount
                            )
                          )
                            ? 1
                            : parseInt(
                                APP.arrangement.booth.extras.find(
                                  (extra) => extra.id === item.DefaultArticle?.id
                                )?.amount
                              ) + 1
                        )
                      }
                      sx={{
                        p: "10px",
                        borderRadius: "0 4px 4px 0",
                        color: "#3A415A",
                        backgroundColor: "#E2E2E2",
                        height: "22px",
                        "&:hover": {
                          backgroundColor: "#E2E2E2 !important",
                        },
                      }}
                    >
                      <AddIcon sx={{ fontSize: "12px" }} />
                    </IconButton>
                  </Box>
                </Box>
              )}
            </Box>

            <Grid item xs={item.NumberInput ? 6 : 12} lg={4}>
              {item.Thumbnail && (
                <Box
                  sx={{
                    width: "120px",
                    height: "100px",
                    padding: "5px",
                    margin: "0 auto 11px auto",
                  }}
                  onMouseDown={() => {}}
                  onTouchStart={() => {}}
                >
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundImage: `url("${item.Thumbnail}")`,
                      backgroundSize: "cover",
                      backgroundColor: "rgb(251 251 251 / 0%)",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                    //TODO: This is bugging sometimes. Fix later on. Maybe P2.
                    ref={(element) => !item.NumberInput && draggable(element, item)} // allows dragging and dropping glb into scene
                  />
                </Box>
              )}
            </Grid>

            {item.NumberInput && (
              // Start for when Item is Number Input (GLB also doesnt appear as an object on screen)
              <Grid item xs={6} lg={8}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "8px",
                    marginBottom: "8px",
                    backgroundColor: "#E2E2E2",
                    borderRadius: "4px",
                    width: "100%",
                    maxWidth: "84px",
                    marginLeft: "auto",
                    marginRight: "10px",
                    [theme.breakpoints.up("lg")]: {
                      marginLeft: 0,
                      marginRight: 0,
                      marginTop: 0,
                      display: "none",
                    },
                  }}
                >
                  <IconButton
                    onClick={(e) =>
                      changeAmount(
                        item,
                        isNaN(
                          parseInt(
                            APP.arrangement.booth.extras.find(
                              (extra) => extra.id === item.DefaultArticle?.id
                            )?.amount
                          )
                        )
                          ? 0
                          : parseInt(
                              APP.arrangement.booth.extras.find(
                                (extra) => extra.id === item.DefaultArticle?.id
                              )?.amount
                            ) - 1
                      )
                    }
                    sx={{
                      p: "6px",
                      borderRadius: "4px 0 0 4px",
                      color:
                        APP.arrangement.booth.extras.find(
                          (extra) => extra.id === item.DefaultArticle?.id
                        )?.amount ?? 0 >= 1
                          ? "#3A415A"
                          : "#939599",
                      backgroundColor: "#E2E2E2",
                      height: "22px",
                      "&:hover": {
                        backgroundColor: "#E2E2E2 !important",
                      },
                    }}
                  >
                    <RemoveIcon sx={{ fontSize: "12px" }} />
                  </IconButton>
                  <InputBase
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                    value={
                      APP.arrangement.booth.extras.find(
                        (extra) => extra.id === item.DefaultArticle?.id
                      )?.amount ?? 0
                    }
                    size="small"
                    onChange={(e) => changeAmount(item, e.target.value)}
                    style={{
                      width: "100%",
                      minWidth: "34px",
                      borderRadius: "4px",
                      padding: "7px",
                      backgroundColor: "#fff",
                      height: "18px",
                      fontSize: "12px",
                    }}
                  />
                  <IconButton
                    onClick={(e) =>
                      changeAmount(
                        item,
                        isNaN(
                          parseInt(
                            APP.arrangement.booth.extras.find(
                              (extra) => extra.id === item.DefaultArticle?.id
                            )?.amount
                          )
                        )
                          ? 1
                          : parseInt(
                              APP.arrangement.booth.extras.find(
                                (extra) => extra.id === item.DefaultArticle?.id
                              )?.amount
                            ) + 1
                      )
                    }
                    sx={{
                      p: "10px",
                      borderRadius: "0 4px 4px 0",
                      color: "#3A415A",
                      backgroundColor: "#E2E2E2",
                      height: "22px",
                      "&:hover": {
                        backgroundColor: "#E2E2E2 !important",
                      },
                    }}
                  >
                    <AddIcon sx={{ fontSize: "12px" }} />
                  </IconButton>
                </Box>
              </Grid>
            )}

            <Grid
              item
              xs={6}
              /* onClick={(event) => handleInterorClick(event, item)} */
            >
              <Typography
                sx={{
                  userSelect: "none",
                  marginBottom: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: "#3A415A",
                  fontWeight: 700,
                  fontSize: "16px",
                }}
                component={"div"}
              >
                {APP.formatter.format(item.DefaultArticle.Preis)}
              </Typography>
            </Grid>

            <Grid
              item
              xs={6}
              /* onClick={(event) => handleInterorClick(event, item)} */
            >
              <Typography
                sx={{
                  color: "#939599",
                  fontSize: "14px",
                  textAlign: "right",
                  marginBottom: 0,
                }}
                component={"div"}
              >
                {I18N("ArticleNumber Label")} {item.ItemNumber}
              </Typography>
            </Grid>
          </GridStyled>
        ))}
      </Box>
    );
  }
}
